import React, { useRef, useState } from "react";
import { CardDeck, Form, FormControl, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import LocationData from "../../../../assets/static/Locations.json";
import LocationCard from "./card";
import "./styles.css";

const meta = (
  <Helmet>
  <title>{`CR21 | Location Resources`}</title>
  <meta
    name="description"
    content={"State and Union Territories based Covid resources"}
  />
</Helmet>
)
function LocationResources() {
  const dispatch = useDispatch();
  // const locations = useSelector(getLocations);
  const locationsRef = useRef(Object.values(LocationData));
  const [search, setSearch] = useState("");
  // logger()(locations);

  // useEffect(() => {
  //   dispatch(loadLocations());
  // }, [dispatch]);

  return (
    <div>
      {meta}
      <Form.Group className="ml-4 mr-4 mt-4" as={Row} controlId="search">
        <FormControl
          type="text"
          placeholder="Search for state/UT"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}
        />
        <Form.Text className="text-muted">
          Please select your state first if you’re looking to find/add some
          resources
        </Form.Text>
      </Form.Group>
      <CardDeck className="m-4 justify-content-between">
        {locationsRef.current
          .map((loc) => loc.toString())
          .filter((loc) => loc.toLowerCase().includes(search))
          .map((loc, id) => (
            <LocationCard key={id} loc={loc} dispatch={dispatch} />
          ))}
      </CardDeck>
    </div>
  );
}

export default LocationResources;
